import SuccessPopUp from './SuccessPopUp';
export default SuccessPopUp;
